import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Provider } from "react-redux";
import Store from "./Core/Data/Store";

require('./Core/Libs/voiceboxer-api-client').init(window.config);

ReactDOM.render(
    <Provider store={Store}>
        <App />
    </Provider>,
    document.getElementById('root')
);

serviceWorker.unregister();